@if (iconTemplate()) {
  <ng-container [ngTemplateOutlet]="iconTemplate()!" />
} @else {
  <span class="h-6">
    <i class="material-symbols-outlined text-info-800"> info </i>
  </span>
}

<div class="flex flex-col gap-1">
  @if (title()) {
    <h3 class="font-semibold text-info-800">
      {{ title() }}
    </h3>
  }
  @if (message()) {
    <p
      class="text-sm text-text-700"
      [ngClass]="{
        'mt-[2px]': !title(),
      }"
    >
      {{ message() }}
    </p>
  }
</div>
